var map = {
	"./PM_2.2.2.png": 80724,
	"./PM_2.3.2.png": 63199,
	"./PM_3.2.2.png": 82091,
	"components/Catalog/PM/img/glass/pr/prPlusPerWhite/PM_2.2.2.png": 80724,
	"components/Catalog/PM/img/glass/pr/prPlusPerWhite/PM_2.3.2.png": 63199,
	"components/Catalog/PM/img/glass/pr/prPlusPerWhite/PM_3.2.2.png": 82091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61866;